import 'moment/locale/en-gb'

import App from '@/App.vue'
import i18n, { loadLocales } from '@/i18n'
import moment from 'moment'
import { extendMoment } from 'moment-range'
import router from '@/router'
import store from '@/store'
import Vue from 'vue'
import vuelidate from 'vuelidate'
import LoadScript from 'vue-plugin-load-script'

import { auditEvent, cloneNode, eventHub, fontAwesome, format, hasPermissions, sessionStorage } from '@/plugins'

import '@/styles/main.css'

/**
 * Dumb component auto-loader
 * Docs: https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
 */
import { upperFirst, camelCase } from 'lodash'

const requireComponent = require.context(
  './components/base',
  true,
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )
  // Register component globally
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false

Vue.use(vuelidate)
Vue.use(require('vue-moment'), { moment: extendMoment(moment) })
Vue.use(LoadScript)
Vue.use(auditEvent)
Vue.use(cloneNode)
Vue.use(eventHub)
Vue.use(fontAwesome)
Vue.use(format)
Vue.use(hasPermissions, { store, router })
Vue.use(sessionStorage)
Vue.use(loadLocales)

const run = () => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

if (!window.Intl.NumberFormat.prototype.formatToParts || !window.Intl.DateTimeFormat.prototype.formatToParts) {
    import('intl').then(({ default: intl }) => {
        import(`intl/locale-data/jsonp/en-GB.js`).then(() => { window.Intl = intl; run() })
    })
} else {
  run()
}
